import React from "react";
import {
  Create,
  FileInput,
  FileField,
  SimpleForm,
  TextInput,
  ReferenceInput,
  AutocompleteInput,
  required,
  useNotify,
  useRedirect,
} from "react-admin";
import Grid from "@mui/material/Grid";
import { THEMATIC_CATALOG_REFS } from "utils/constants";
import CustomDateInput from "common/components/Fields/CustomDateInput";

const ImportEdition = props => {
  const notify = useNotify();
  const redirect = useRedirect();
  const onSuccess = data => {
    notify(`Файлът е качен успешно!`, { type: "success" });
    redirect(`/editions`);
  };
  const onError = error => {
    notify(` ${error.message}`, { type: "error" });
  };
  return (
    <Create
      mutationOptions={{ onSuccess, onError }}
      title="Създаване на продукти за абонамента"
    >
      <SimpleForm>
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={10}
          >
            <TextInput
              label="Име на кампанията"
              source="campaign_name"
              fullWidth={true}
              validate={required()}
            />
          </Grid>

          <Grid
            item
            md={6}
            lg={4}
          >
            <CustomDateInput
              label="Начална дата на кампанията"
              source="campaign_start_date"
              fullWidth
              validate={required()}
            />{" "}
          </Grid>
          <Grid
            item
            md={6}
            lg={4}
          >
            <CustomDateInput
              label="Крайна дата на кампанията"
              source="campaign_end_date"
              fullWidth
              validate={required()}
            />{" "}
          </Grid>

          <Grid
            item
            md={6}
            lg={4}
          >
            <CustomDateInput
              label="Дата на начало на абонаментa"
              source="subscription_start_date"
              fullWidth
              validate={required()}
            />
          </Grid>
        </Grid>
        <ReferenceInput
          source="thematic_catalog_group_id"
          reference={THEMATIC_CATALOG_REFS}
        >
          <AutocompleteInput
            label="Тема"
            optionText="name"
            fullWidth
          />
        </ReferenceInput>
        <FileInput
          placeholder="Добавете файл с  издания и валидните за тях абонаменти в XLS формат"
          label="Издания"
          source="file"
          accept=".xls , .xlsx"
        >
          <FileField
            source="src"
            title="title"
            label={null}
          />
        </FileInput>
      </SimpleForm>
    </Create>
  );
};

export default ImportEdition;
